// extracted by mini-css-extract-plugin
module.exports = {"content":"Product_content__3g0wp","submitBtn":"Product_submitBtn__2w_Dr","checkbox":"Product_checkbox__1n71Q"};